/* unplugin-vue-components disabled */import { render } from "./ManagerAssign.vue?vue&type=template&id=7708214c&scoped=true"
import script from "./ManagerAssign.vue?vue&type=script&lang=js"
export * from "./ManagerAssign.vue?vue&type=script&lang=js"

import "./ManagerAssign.vue?vue&type=style&index=0&id=7708214c&scoped=true&lang=css"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7708214c"]])

export default __exports__